<div class="dialog-content-wrapper">
    <mat-toolbar class="bg-primary m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">Actualización Configuración</span>
            <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
            <mat-form-field appearance="outline" fxFlex="100">
                <mat-label>Cambio configuración</mat-label>
                <mat-select (selectionChange)="changeTipo($event.value)">
                    <mat-option *ngFor="let tipo of tipos" [value]="tipo.value">{{tipo.label}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="end end">
        <button class="mr-8" mat-raised-button type="button" (click)="dialogRef.close()">
            Cancelar
        </button>
        <button (click)="save()" mat-raised-button type="button" color="accent" [disabled]="!(tipo !== '')">
            Guardar
        </button>
    </div>
</div>
